import {useTranslation} from 'react-i18next'
import {toast} from 'react-toastify'

import {fetcher, putHeaders, deleteHeaders} from '../../api'
import {useRails} from '../contexts/rails'

import {ToastMessage} from '../components'
import {CheckIcon, CrossIcon} from '../icons'
import useErrorTranslate from './useErrorTranslate'

const useLogoUpload = (mutate) => {
  const {t} = useTranslation('logoUpload')
  const {organisation, authenticityToken, directUploadsUrl} = useRails()

  const onErrorsTranslate = useErrorTranslate(t, 'errors')

  const onUpdateLogo = async (signedId) => {
    const result = await fetcher(
      `/api/suppliers/${organisation.currentSupplier.id}/business_settings`,
      putHeaders({
        authenticityToken,
        raiseClientErrors: false,
        body: {logo: signedId},
      }),
    )

    if (!result.success) {
      const messages = onErrorsTranslate(result.errors)

      toast.dark(
        <ToastMessage>
          <CrossIcon mr={1} color="mld.alert.700" />
          {messages.join(', ')}
        </ToastMessage>,
      )

      return
    }

    toast.dark(
      <ToastMessage>
        <CheckIcon mr={1} color="mld.success.700" />
        {t('upload.success')}
      </ToastMessage>,
    )

    if (mutate) {
      mutate()
    }
  }

  const onDestroyLogo = async () => {
    await fetcher(
      `/api/suppliers/${organisation.currentSupplier.id}/business_settings`,
      deleteHeaders({authenticityToken}),
    )

    if (mutate) {
      mutate()
    }
  }

  return {
    onUpdateLogo,
    onDestroyLogo,
    directUploadsUrl,
  }
}

export default useLogoUpload
